// extracted by mini-css-extract-plugin
module.exports = {"title":"dC","status":"dD","isRental":"dE"};